import type { IconData } from '@stacksjs/iconify-core'

export const weatherTemperatureThermometer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20.565 4.57h6.1V6.1h-6.1Zm0 12.2h6.1v1.52h-6.1Zm0-6.1h6.1v1.52h-6.1ZM6.855 30.48h1.52V32h6.1v-1.52H16v-1.52h1.53v-6.1H16v-1.52h-1.52V1.53h-1.53v13.71H9.9V1.53H8.375v19.81h-1.52v1.52h-1.52v6.1h1.52Zm6.09-7.62h1.53v1.52H16v3.05h-1.52v-3.05h-1.53ZM9.905 0h3.04v1.53h-3.04Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default weatherTemperatureThermometer
